import { atom } from "jotai";
import { graphql, readInlineData } from "react-relay";

import { currentItemAtom } from "scmp-app/lib/current-item";
import type { atomsCurrentTakeoverAdSectionsAtomBase$key } from "scmp-app/queries/__generated__/atomsCurrentTakeoverAdSectionsAtomBase.graphql";

export const currentTakeoverAdSectionsAtom = atom(get => {
  const currentItem = get(currentItemAtom);
  if (!currentItem) return [];

  const item = readInlineData<atomsCurrentTakeoverAdSectionsAtomBase$key>(
    graphql`
      fragment atomsCurrentTakeoverAdSectionsAtomBase on BaseWithApplicationAndUrlAlias @inline {
        __typename
        ... on Article {
          sectionsV2 {
            value {
              ... on Section {
                entityId
              }
            }
          }
        }
        ... on Section {
          fullSectionPath {
            entityId
          }
        }
      }
    `,
    currentItem,
  );

  switch (item.__typename) {
    case "Article":
      if (!item.sectionsV2?.length) return [];
      return item.sectionsV2
        .flatMap(section => section?.value ?? [])
        .flatMap(element => element?.entityId ?? []);
    case "Section":
      return item.fullSectionPath?.flatMap(s => s?.entityId ?? []) ?? [];
    default:
      return [];
  }
});

export const isShowTakeoverAdSlotAtom = atom(false);
